
    <template>
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 19 21">
  <path
    d="M17.919 12.1448C17.545 11.137 16.0802 8.86182 16.0594 7.71903H16.049C16.049 7.6567 16.0594 7.59437 16.0594 7.53203C16.0594 3.37643 13.0778 0 9.40006 0C5.72235 0.010389 2.74071 3.37643 2.74071 7.54242C2.74071 7.60475 2.7511 7.66709 2.7511 7.72942H2.74071C2.71993 8.87221 1.26547 11.1474 0.881073 12.1551C0.49668 13.1629 0.403179 14.1706 0.579792 14.981C0.756405 15.7809 0.901852 16.2796 1.06808 16.4354C1.2343 16.5912 1.39013 16.7679 1.88881 16.4042C2.29398 16.0718 2.73032 15.3965 2.73032 15.3965C2.73032 15.3965 3.09393 16.4458 3.90428 17.2561C3.27055 17.5574 2.34592 18.2223 2.28359 18.6691C2.22126 19.1054 3.24977 20.7572 5.67041 20.7988C8.09105 20.83 8.891 19.7911 8.97411 19.708C9.20267 19.469 9.38967 19.3236 9.38967 19.3236C9.38967 19.3236 9.58706 19.469 9.80523 19.708C9.88834 19.7911 10.6883 20.8404 13.1089 20.7988C15.5296 20.7572 16.5581 19.1054 16.4958 18.6691C16.4334 18.2327 15.5088 17.5574 14.8751 17.2561C15.6854 16.4562 16.049 15.3965 16.049 15.3965C16.049 15.3965 16.4854 16.0718 16.8905 16.4042C17.3892 16.7575 17.545 16.5912 17.7113 16.4354C17.8775 16.2796 18.0229 15.7809 18.1996 14.981C18.3969 14.1706 18.2931 13.1525 17.919 12.1448Z"
    fill="currentColor"
  ></path>
</svg>

    </template>

    <script lang="ts">
    import type { DefineComponent } from 'vue'
    export default ({
      name: 'Qq',
    }) as DefineComponent
    </script>
    